import { apiFetch, ApiError } from './client'
import { healthResponseSchema, type HealthResponse } from '@/lib/schemas/health'

/** System Health API (Screen 7). One getter re-run on demand by [Refresh]. */

function messageFromBody(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') return undefined
  const detail = (body as { detail?: unknown }).detail
  return typeof detail === 'string' ? detail : undefined
}

/** GET /api/health/status — the 8 checks, server-ordered. */
export async function getHealth(): Promise<HealthResponse> {
  const res = await apiFetch('/api/health/status', { method: 'GET' })
  if (!res.ok) {
    const body = await res.json().catch(() => null)
    const detail = messageFromBody(body)
    throw new ApiError(res.status, detail ?? `Failed to load health status (${res.status})`, detail)
  }
  return healthResponseSchema.parse(await res.json())
}
